import React from 'react';

export function Input({
  label,
  error,
  helperText,
  id,
  required,
  className = '',
  ...props
}) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="block text-small text-foreground">
          {label}
          {required && <span className="text-muted ml-1">*</span>}
        </label>
      )}
      <input
        id={inputId}
        required={required}
        className={`
          w-full px-4 py-3 bg-secondary border text-foreground text-body
          placeholder:text-muted focus:outline-none focus:border-foreground
          transition-colors duration-normal
          ${error ? 'border-red-500' : 'border-border'}
        `}
        {...props}
      />
      {(error || helperText) && (
        <p className={`text-caption ${error ? 'text-red-400' : 'text-muted'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
}

export default Input;
